export default "__VITE_ASSET__4vwCHln8__"